var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Confirm Instruction")]),_c('ProceedYN',{model:{value:(_vm.form.proceed),callback:function ($$v) {_vm.$set(_vm.form, "proceed", $$v)},expression:"form.proceed"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }